<template>
  <layout
    title="Developer-first face authentication"
    :transparent="true"
    :mobileHeroOverlay="true"
    class="overflow-x-hidden"
  >
    <highlightSection
      backgroundImage="/storage/images/home/decentralized_biometrics_for_trust_at_global_scale.jpg"
      mobileBackgroundImage="/storage/images/home/decentralized_biometrics_for_trust_at_global_scale_mobile.png"
      mobileBackgroundMedia="(max-width: 767px)"
      :mobileHeroOverlay="true"
      heightClass="aspect-[1097/822] md:aspect-auto md:h-[400px] 2xl:h-[550px]"
      desktopContentWrapperClass="py-1 md:pt-16 md:pb-0 xl:py-8"
      desktopContentContainerClass="mt-0 md:h-[calc(100%-4rem)] md:flex md:flex-col md:justify-center xl:mt-14 xl:h-auto xl:block"
      desktopContentBlockClass="mt-0 md:mt-0"
      buttonsRowClass="mt-5 md:mt-8"
      styleImage="object-[100%_0%] md:object-[82%_center] xl:object-[86%_center]"
      leftButtonClass="min-w-[116px] md:min-w-40"
      altImage="Decentralized Authentication Youverse"
      title="Decentralized biometrics for trust at global scale"
      subtitle="Build custom identity workflows with only 3 lines of code. Faster, more agile and cheaper than legacy identity providers."
      leftButton="Book a Demo"
      urlLeftButton="book-a-meeting"
    />
    <section2 />
    <partners />
    <section9 />
    <section10 />
    <section11 />
    <div class="my-5">
      <cta
        variant="dual"
        title="Ready to ship private‑by‑design identity?"
        text="Start free in minutes, or connect with our team for custom deployment."
        buttonText="Choose your plan"
        buttonLink="/pricing"
        secondaryTarget="_blank"
        secondaryButtonText="Ask for a quote"
        secondaryButtonLink="/book-a-meeting"
      />
    </div>
    <section7 />
    <LatestPostsSection />
    <div class="my-5">
      <NewsletterCTA
        title="Don’t miss our latest articles and insights"
        text="Stay informed with our latest updates"
      />
    </div>
  </layout>
</template>

<script>
const layout = () => import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

const highlightSection = () =>
  import(/* webpackChunkName: "highlightSection" */ "../Components/Layout/highlightSection.vue");

const section2 = () =>
  import(/* webpackChunkName: "section2" */ "../Components/Layout/HomePage/section2.vue");

const partners = () =>
  import(/* webpackChunkName: "partners" */ "../Components/Layout/HomePage/partners.vue");

const section9 = () =>
  import(/* webpackChunkName: "section9" */ "../Components/Layout/HomePage/section9.vue");

const section10 = () =>
  import(/* webpackChunkName: "section10" */ "../Components/Layout/HomePage/section10.vue");

const section11 = () =>
  import(/* webpackChunkName: "section11" */ "../Components/Layout/HomePage/section11.vue");

const cta = () => import(/* webpackChunkName: "cta" */ "../Components/Layout/cta.vue");

const section7 = () =>
  import(/* webpackChunkName: "section7" */ "../Components/Layout/HomePage/section7.vue");

const LatestPostsSection = () =>
  import(
    /* webpackChunkName: "LatestPostsSection" */ "../Components/Layout/HomePage/LatestPostsSection.vue"
  );

const NewsletterCTA = () =>
  import(/* webpackChunkName: "NewsletterCTA" */ "../Components/Layout/NewsletterCTA.vue");

export default {
  components: {
    layout,
    highlightSection,
    section2,
    partners,
    cta,
    section7,
    section9,
    section10,
    section11,
    LatestPostsSection,
    NewsletterCTA,
  },
  props: {
    errors: Object,
  },
};
</script>
